/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AppInitService } from './@core/services/app-init.service';
import { AnalyticsService } from './@core/utils/analytics.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private appInitService: AppInitService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    // Initialize app data (company data) at startup
    await this.appInitService.init();

    // Track page views
    this.analytics.trackPageViews();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts